import { InjectionToken } from '@angular/core';

export enum EntityStoreKey {
  featureFlags = 'featureFlags',
}

export type FeatureFlagsMap = Record<FeatureFlag, boolean>;
export const FEATURE_FLAGS = new InjectionToken<FeatureFlagsMap>('Feature flags map');

export enum FeatureFlag {
  DisableZiggeo = 'disable-ziggeo',
  Referrals = 'referrals', // This flag should be migrated to pricing features after release
  NewCareers = 'new_careers',
  EventDebug = 'debug_event_tracking',
  Requisitions = 'requisitions_flag',
  MarkAsHired = 'mark_as_hired',
  AdyenDisableLocalMethods = 'adyen_disable_local_methods',
  AdyenDisableLocalMethodsNotice = 'adyen_disable_local_methods_notice',
  BrockmeyerAdyenDropin = 'brockmeyer_adyen_dropin',
  VonqAcquisition = 'vonq_acquisition',
  Hotjar = 'hotjar',
}
